import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=0ea42b08&scoped=true&"
import script from "./AlertDetails.vue?vue&type=script&lang=js&"
export * from "./AlertDetails.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetails.vue?vue&type=style&index=0&id=0ea42b08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea42b08",
  null
  
)

export default component.exports